import { defineStore } from 'pinia';
import { MenuState, IMenuItem } from './type';
import { uniq } from 'lodash-es';
import { parse, stringify } from 'qs';
// eslint-disable-next-line import/no-cycle
import { userFindMenuTree } from '@/api/iam/user';
import { CURRENT_CLIENT_CODE } from '@/constant';
import { MENU_TYPE_ENUM } from '@/api/iam/user/constant';
import { RouteLocationNormalized } from 'vue-router';

// 首页路由配置
const BASE_ROUTE: IMenuItem[] = [
  {
    parentId: '-1',
    id: '-1',
    componentName: 'Dashboard',
    name: '首页',
    type: MENU_TYPE_ENUM.MENU,
    icon: 'font_family icon-shouye1',
  },
];
const TEMPLATE_ROUTE: IMenuItem[] = [
  {
    parentId: '-1',
    id: '-2',
    componentName: 'Template',
    name: '模板',
    type: MENU_TYPE_ENUM.MENU,
    icon: 'font_family icon-shouye1',
    children: [
      {
        parentId: '-2',
        id: '-3',
        componentName: 'TemplateList',
        name: '列表模板',
        type: MENU_TYPE_ENUM.MENU,
        children: [],
      },
      {
        parentId: '-2',
        id: '-4',
        componentName: 'KeepAlivePage1',
        name: 'KeepAlive示例',
        type: MENU_TYPE_ENUM.MENU,
        children: [],
      },
      {
        parentId: '-2',
        id: '-5',
        componentName: 'TemplateComponents',
        name: '组件Demo',
        type: MENU_TYPE_ENUM.MENU,
        children: [],
      },
    ],
  },
];

export const useMenuStore = defineStore({
  id: 'menu',
  state: (): MenuState => ({
    menus: [],
    needReload: false,
    isGetMenu: false,
    authMenuList: [],
    authButtonList: [],
    flatMenus: [],
    activeMenu: '',
  }),

  actions: {
    async getMenus() {
      try {
        if (this.isGetMenu) return;
        const { data } = await userFindMenuTree([CURRENT_CLIENT_CODE]);
        const resourceTreeVos: IMenuItem[] = [...BASE_ROUTE];
        if (process.env.NODE_ENV === 'development') {
          resourceTreeVos.push(...TEMPLATE_ROUTE);
        }
        Object.keys(data).forEach((key) => {
          resourceTreeVos.push(...data[key]);
        });
        const authMenuList: string[] = [
          'Dashboard',
          'SelectReferencePic',
          'SelectBgPic',
          'InspirationCenterAiStudioBatchCreate'
        ];
        const authButtonList: string[] = [];
        const flatMenus: IMenuItem[] = [];
        const deep = (menuTree: IMenuItem[], parentId: string = '-1'): IMenuItem[] => {
          return menuTree.map((it) => {
            const row = {
              ...it,
              parentId,
            } as IMenuItem;
            if (row.type === MENU_TYPE_ENUM.MENU) {
              let path = row.componentName || row.url;
              if (path) {
                if (path.includes('?')) {
                  const [routeName, search] = path.split('?');
                  path = routeName;
                  row.componentName = path;
                  row.query = parse(search) as unknown as any;
                }
                authMenuList.push(path);
              }
              flatMenus.push(row);
            }
            if (row.children?.length && row.type === MENU_TYPE_ENUM.MENU) {
              row.children = deep(row.children, row.id);
            } else if (row.type === MENU_TYPE_ENUM.BUTTON) {
              if (row.url) {
                authMenuList.push(...row.url.split(','));
              }
              if (row.componentName) {
                authMenuList.push(row.componentName);
              }
            }
            if (row.code) {
              authButtonList.push(row.code);
            }
            return row;
          });
        };
        // 外部应用的不在菜单展示
        this.menus = deep(resourceTreeVos).filter(item => item.code !== 'FASHION-WBYY');
        console.log('this.menus', this.menus);
        this.flatMenus = flatMenus;
        this.authMenuList = uniq(authMenuList);
        this.authButtonList = uniq(authButtonList);
        this.isGetMenu = true;
      } catch (error) {
        // 获取菜单失败 清空菜单
        this.clearMenus();
        throw Error('获取资源失败');
      }
    },
    clearMenus() {
      this.menus = [...BASE_ROUTE];
      this.authMenuList = [];
      this.authButtonList = [];
      this.flatMenus = [];
      this.isGetMenu = false;
    },
    setActiveMenu(menu: string) {
      this.activeMenu = menu;
    },
    hasPermission(code: string): boolean {
      if (process.env.NODE_ENV === 'development') {
        return true;
      }
      return this.authButtonList.includes(code);
    },

    hasMenu(route: RouteLocationNormalized) {
      if (process.env.NODE_ENV === 'development') {
        return true;
      }
      return this.authMenuList.includes(route.name as string);
    },
    getMenu(routeName: string) {
      return this.flatMenus.find((item) => {
        return item.componentName
          && item.type === MENU_TYPE_ENUM.MENU
          && `${item.componentName}${item.query ? `?${stringify(item.query)}` : ''}` === routeName;
      });
    }
  },
});
